export default __webpack_public_path__ + "static/media/Boneshard.ebc3e0fb.jpg";